import styled from 'styled-components';

export const StyledExploreItems = styled.div`
  width: 100%;
  height: ${({ theme }) => theme.avatarSize};
  min-height: ${({ theme }) => theme.avatarSize};
  cursor: pointer;
  border: solid ${({ theme }) => theme.buttonFrameWidth} transparent;
  overflow: hidden;
  transition: background linear 0.2s;

  .explore-items-content {
    border: dashed ${({ theme }) => theme.buttonFrameWidth} ${({ theme }) => theme.frame};
    position: relative;
    width: 100%;
    height: 100%;
  }

  .explore-items-label-holder {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .explore-items-label {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    transition: background linear 0.2s;
    background: transparent;
    text-transform: uppercase;
    font-family: "BebasNeue";
    font-weight: 700;
    font-size: 2rem;
    line-height: 1;
    color: white;
    opacity: 0.0;
    transition: opacity linear 0.2s;

    .corner-left {
      border: solid 2px ${({ theme }) => theme.buttonLightBlue};
      border-right: none;
      width: 6px;
    }

    .label {
      transition: padding linear 0.2s;
      padding-top: 6px;
      padding-left: 12px;
      padding-right: 12px;
    }
    
    .corner-right {
      border: solid 2px ${({ theme }) => theme.buttonLightBlue};
      border-left: none;
      width: 6px;
    }
  }

  .explore-items-img {
    transition: scale linear 0.2s;
    width: 100%;
    height: 100%;
  }

  .explore-items-action-icon {
    position: absolute;
    bottom: 8px;
    left: 8px;
    width: ${({ theme }) => theme.actionIconSize};
    height: ${({ theme }) => theme.actionIconSize};
    transition: opacity linear 0.2s;
    opacity: 0.0;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &:hover {
    .explore-items-img {
      scale: 1.2;
    }

    .explore-items-action-icon {
      opacity: 1.0;
    }

    .explore-items-label {
      opacity: 1.0;
    }
    .explore-items-type {
      transform: translateX(0px);
    }

    .explore-items-number {
      opacity: 1.0;
    }
  }

  .explore-items-img-wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding: 8px;
  }

  .explore-items-type {
    position: absolute;
    top: 8px;
    right: 8px;
    font-family: "NeueMachina";
    font-size: 1rem;
    color: white;
    text-transform: lowercase;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    transform: ${({ theme }) => 'translateX(' + theme.invNumberSize + ')'};
    transition: linear 0.2s;
  }

  .explore-items-type-name {
    opacity: 0.4;
  }

  .explore-items-number {
    opacity: 0.0;
    width: ${({ theme }) => theme.invNumberSize};
    text-align: end;
    overflow: hidden;

    span {
      font-family: "BebasNeue";
      font-size: 1.25rem;
      opacity: 0.4;
    }

    .number {
      color: ${({ theme }) => theme.baseRed};
      opacity: 1.0;
    }
  }
`;
